import { Link } from "react-router-dom";
import { Logo } from "./Logo";
import { ExternalLink, MapPin, Mail, Phone } from "lucide-react";

const EMPLOYEE_PORTAL = "https://hma.snawbar.net/dashboard";

export const Footer = () => (
  <footer className="relative bg-slate-50 border-t border-slate-200/80 overflow-hidden" data-testid="site-footer">
    <div className="pointer-events-none absolute -right-10 -bottom-20 font-heading font-extrabold text-[180px] text-slate-900/[0.02] leading-none select-none">
      HMA
    </div>
    <div className="relative max-w-7xl mx-auto px-5 sm:px-8 py-16 grid gap-12 md:grid-cols-4">
      <div className="md:col-span-1">
        <Logo />
        <p className="mt-5 text-sm text-slate-500 leading-relaxed">
          Advanced chemical solutions for high-performance concrete. Manufacturing concrete admixtures and cement
          grinding aids in Iraq since 2009.
        </p>
      </div>

      <div>
        <h4 className="text-xs uppercase tracking-widest font-mono text-brand-400 mb-4">Navigate</h4>
        <ul className="space-y-2 text-sm text-slate-600">
          <li><Link to="/" className="hover:text-brand-400 transition-colors">Home</Link></li>
          <li><Link to="/about" className="hover:text-brand-400 transition-colors">About Us</Link></li>
          <li><Link to="/products" className="hover:text-brand-400 transition-colors">Data Sheets</Link></li>
          <li><Link to="/projects" className="hover:text-brand-400 transition-colors">Projects</Link></li>
          <li><Link to="/faq" className="hover:text-brand-400 transition-colors">FAQ</Link></li>
          <li><Link to="/contact" className="hover:text-brand-400 transition-colors">Contact</Link></li>
        </ul>
      </div>

      <div>
        <h4 className="text-xs uppercase tracking-widest font-mono text-brand-400 mb-4">Resources</h4>
        <ul className="space-y-2 text-sm text-slate-600">
          <li>
            <a href={EMPLOYEE_PORTAL} target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-1.5 hover:text-brand-400 transition-colors" data-testid="employee-portal-footer">
              Employee Portal <ExternalLink size={12} />
            </a>
          </li>
          <li><Link to="/products" className="hover:text-brand-400 transition-colors">Technical Data Sheets</Link></li>
          <li><Link to="/admin" className="hover:text-brand-400 transition-colors" data-testid="footer-admin-link">Admin Login</Link></li>
        </ul>
      </div>

      <div>
        <h4 className="text-xs uppercase tracking-widest font-mono text-brand-400 mb-4">Contact</h4>
        <ul className="space-y-3 text-sm text-slate-600">
          <li className="flex items-start gap-2"><MapPin size={16} className="text-brand-400 mt-0.5" /> Plants in Sulaymaniyah &amp; Baghdad, Iraq</li>
          <li className="flex items-center gap-2"><Mail size={16} className="text-brand-400" /> hma.iraq@hmachemicals.com</li>
          <li className="flex items-start gap-2"><Phone size={16} className="text-brand-400 mt-0.5" />
            <span className="flex flex-col">
              <a href="tel:+9647700022222" className="hover:text-brand-400 transition-colors">+964 770 002 2222</a>
              <a href="tel:+9647503339999" className="hover:text-brand-400 transition-colors">+964 750 333 9999</a>
              <a href="tel:+9647701578678" className="hover:text-brand-400 transition-colors">+964 770 157 8678</a>
            </span>
          </li>
        </ul>
      </div>
    </div>
    <div className="relative border-t border-slate-200/80 py-6 text-center text-xs text-slate-500">
      © {new Date().getFullYear()} HMA Concrete Admixtures. All rights reserved.
    </div>
  </footer>
);
